import { useLocation } from 'react-router-dom';

function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

function useParamsRoute(props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const entries = searchParams.entries();
  const result = {};

  for (const [key, value] of entries) {
    result[key] = props !== null && props !== void 0 && props.skipParseNum ? value : isNumeric(value) ? Number(value) : value;
  }

  return result;
}

export default useParamsRoute;